import React from 'react';
import { ReservationApp } from '../pageComponents/reservationPage';
import { renderPage } from '../common/renderPage';

renderPage(<ReservationApp />, "#ReservationPage");